export default __webpack_public_path__ + "static/case-ai-1-311917a70d8b6ff92550d3fec6ba184d.jpg";